//export const API_BASE_URL = 'http://192.168.1.42:8080'; // Change this to your current IP or localhost


export const API_BASE_URL = 'http://140.245.240.176:8080';